const firebaseConfig = {
  apiKey: "AIzaSyDsR5_cz5zMWAuOUNAtTJuA55L8rBoaIcU",
  authDomain: "doctorsportal11.firebaseapp.com",
  projectId: "doctorsportal11",
  storageBucket: "doctorsportal11.appspot.com",
  messagingSenderId: "137651684288",
  appId: "1:137651684288:web:1696e29e0ddd0077effe25",
};

export default firebaseConfig;
